import { useEffect, useState } from "react";
import {
    Form,
    Table,
    Button,
    Modal,
    Input,
    Avatar,
    Card,
    InputNumber,
    message,
} from "antd";
import { host } from "../../config";
import { useNavigate } from "react-router-dom";
const { Meta } = Card;
export default function App(props) {
    const token = localStorage.getItem("token");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [config, setConfig] = useState();
    const [isBaseModalOpen, setIsBaseModalOpen] = useState(false);
    const [options, setOptions] = useState();
    const [TableData, setTableData] = useState(props.data?.trade);
    const [data, setData] = useState();
    const [selectedElement, setSelectedElement] = useState(null);
    const navigate = useNavigate();
    const screenWidth = window.innerWidth;
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const showModalBase = () => {
        setIsBaseModalOpen(true);
     };
     const handleOkBase = () => {
        setIsBaseModalOpen(false);
    };
    const handleCancelBase = () => {
        setIsBaseModalOpen(false);
    };

    const selectFilter = (owner, index) => {
        var filteredData = props.data?.trade.filter((e) => e.owner === owner);

        setSelectedElement(index);
        setTableData(filteredData);
    };

    const fetchQrcode = (e) => {
        if (e) {
            fetch(host + "/api/base", {
                method: "PUT",
                headers: {
                    Authorization: "Bearer " + token,
                    "Content-type": "application/json; charset=UTF-8",
                },
                body: JSON.stringify({
                    qrcode: e,
                }),
            })
                .then((res) => res.json())
                .then((res) => {
                    window.location.reload();
                })
                .catch((err) => {
                    console.log(err);
                    message.error(err);
                });
        }
    };

    useEffect(() => {
        fetch(host + "/api/config", {
            method: "GET",
            headers: {
                Authorization: "Bareer " + token,
            },
        })
            .then((res) => res.json())
            .then((res) => {
                setConfig(res);
            })
            .catch((err) => console.log(err.message));

        fetch(host + `/api/invoice`, {
            method: "POST",
            headers: {
                Authorization: "Bareer " + token,
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: JSON.stringify({
                date: config?.date,
            }),
        })
            .then((res) => res.json())
            .catch((err) => console.log(err.message));

        fetch(host + "/api/database/onlynames", {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
            },
        })
            .then((res) => res.json())
            .then((res) => setOptions(res));
    }, []);

    const fetchPost = (e) => {
        fetch(host + "/api/base", {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                "Content-type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(e),
        })
            .then((res) => res.json())
            .then((res) => {
                window.location.reload();
            })
            .catch((err) => {
                console.log(err);
                message.error(err);
            });
    };

    const fetchDelet = (e) => {
        fetch(host + "/api/base", {
            method: "DELETE",
            headers: {
                Authorization: "Bearer " + token,
                "Content-type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify({
                _id: e,
            }),
        })
            .then((res) => res.json())
            .then((res) => {
                window.location.reload();
            })
            .catch((err) => console.log(err.message));
    };

    const columns = [
        {
            title: "T/R",
            dataIndex: "index",
            render(record, index) {
                return {
                    children: <div>{props.data?.trade.indexOf(index) + 1}</div>,
                };
            },
        },
        {
            title: "Model Nomi",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Model Bazasi",
            dataIndex: "owner",
            key: "owner",
        },
        {
            title: "Vesi",
            dataIndex: "",
            key: "weight",
            render: (e) => <p>{e.weight.toFixed(2)}</p>,
        },
        {
            title: "Ustidigi molda",
            dataIndex: "",
            key: "plus",
            render: (e) => <p>{e.plus.toFixed(2)}</p>,
        },
        // {
        //     title: "O'chirish",
        //     dataIndex: "",
        //     key: "x",
        //     render: (e) => (
        //         <Button
        //             type="primary"
        //             onFocus={playSound}
        //             onClick={() => fetchDelet(e._id)}
        //             danger
        //         >
        //             Delete
        //         </Button>
        //     ),
        // },
    ];

    const playSound = () => {
        // Replace 'sound.mp3' with the path to your sound file
        const audio = new Audio("/error-call-to-attention-129258.mp3");

        audio.play();
    };
    const sums = {};

    if (props.data?.trade) {
        for (const item of props.data.trade) {
            const owner = item.owner;
            const weight = item.weight;
            const plus = item.plus;

            if (sums[owner]) {
                sums[owner].weight += weight;
                sums[owner].plus += plus;
            } else {
                sums[owner] = { weight, plus };
            }
        }
    }

    const insert2Trade = function (e) {
        fetch(host + `/api/divison/${props.data?._id}/insert2Trade`, {
            method: "post",
           headers: {
                Authorization: "Bearer " + token,
                "Content-type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(e),
        })
            .then((res) => res.json())
            .then((res) => {
                window.location.reload();
            })
            .catch((err) => console.log(err.message));
    } 
    var all_plus = 0;
    props.data?.trade?.map((el) => (all_plus += el.plus));

    var all_weight = 0;
    props.data?.trade?.map((el) => (all_weight += el.weight));
    return (
        <>
            <div className="center">
                <h1 style={{ padding: "20px" }}>Umumiy baza</h1>
                <p>All weight: {all_weight.toFixed(2)} </p>
                <p>All plus: {all_plus.toFixed(2)}</p>
                <Button type="primary"
                        style={{ margin: "5px" }}
                    onClick={showModalBase}
                >
                        Model qo'shish
                    </Button>
                <Button
                    type="primary"
                    style={{
                        marginLeft: "10px",
                        background: "lightgrey",
                        cursor: "pointer",
                        color: "white",
                    }}
                    onClick={() => {
                        navigate("/print2", {
                            state: TableData,
                        });
                    }}
                >
                    Print
                </Button>

                <>
                    <div className="element">
                        {Object.entries(sums).map(([owner, values], index) => (
                            <div key={owner} className="responsive-column">
                                <Card
                                    className="dashboard-card"
                                    onClick={(e) => {
                                        selectFilter(owner, index);
                                    }}
                                    style={{
                                        border:
                                            selectedElement === index
                                                ? "2px solid #1890ff"
                                                : "",
                                        cursor: "pointer",
                                    }}
                                >
                                    <Meta
                                        avatar={
                                            <Avatar
                                                className="avatarIcon"
                                                size={"large"}
                                            >
                                                {owner}
                                            </Avatar>
                                        }
                                        title={values.weight.toFixed(2)}
                                        description={values.plus.toFixed(2)}
                                    />
                                </Card>
                            </div>
                        ))}
                    </div>

                    <Table
                        columns={columns}
                        expandable={{
                            expandedRowRender: (record) => (
                                <p
                                    style={{
                                        margin: 0,
                                    }}
                                >
                                    {record.description}
                                </p>
                            ),
                            rowExpandable: (record) => record.description,
                        }}
                        dataSource={TableData}
                        pagination={false}
                    />

                    <Modal
                        title="Yangi model qo'shish"
                        footer={null}
                        open={isModalOpen}
                        onOk={handleOk}
                        onCancel={handleCancel}
                    >
                        <Form
                            onFinish={(e) => {
                                fetchPost(e);
                            }}
                            style={{
                                maxWidth: 300,
                                margin: "0 auto",
                            }}
                        >
                            <Form.Item
                                name="name"
                                label="Nomi"
                                rules={[
                                    {
                                        required: true,
                                        message: "Nomini yozing",
                                    },
                                ]}
                            >
                                <Input placeholder="Model nomini tanlang" />
                            </Form.Item>
                            <Form.Item
                                name="weight"
                                label="Vesi"
                                rules={[
                                    {
                                        required: true,
                                        message: "Vesini yozing",
                                    },
                                ]}
                            >
                                <Form.Item name="weight" noStyle>
                                    <InputNumber
                                        style={{
                                            width: "auto",
                                        }}
                                        min={0.01}
                                        max={999.99}
                                    />
                                </Form.Item>
                            </Form.Item>

                            <Form.Item name="price" label="Narxi">
                                <Form.Item name="price" noStyle>
                                    <InputNumber
                                        style={{
                                            width: "auto",
                                        }}
                                    />
                                </Form.Item>
                            </Form.Item>

                            <Form.Item
                                name="owner"
                                label="Baza"
                                rules={[
                                    {
                                        required: true,
                                        message: "Baza harfini yozing",
                                    },
                                ]}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Button
                                type="primary"
                                style={{
                                    width: "100%",
                                }}
                                htmlType="submit"
                            >
                                Qo'shish
                            </Button>
                        </Form>
                    </Modal>
                </>
            </div>

            <Modal
                        title="Yangi model qo'shish"
                        footer={null}
                        open={isBaseModalOpen}
                        onOk={handleOkBase}
                        onCancel={handleCancelBase}
                    >
                        <Form
                            onFinish={(e) => {
                                console.log(e)
                                insert2Trade(e)
                                // fetchPostBsz(e);
                            }}
                            style={{
                                maxWidth: 300,
                                margin: "0 auto",
                            }}
                        >
                            <Form.Item
                                name="name"
                                label="Nomi"
                                rules={[
                                    {
                                        required: true,
                                        message: "Nomini yozing",
                                    },
                                ]}
                            >
                                <Input placeholder="Model nomini tanlang" />
                            </Form.Item>
                            <Form.Item
                                name="weight"
                                label="Vesi"
                                rules={[
                                    {
                                        required: true,
                                        message: "Vesini yozing",
                                    },
                                ]}
                            >
                                <Form.Item name="weight" noStyle>
                                    <InputNumber
                                        style={{
                                            width: "auto",
                                        }}
                                        min={0.01}
                                        max={999.99}
                                    />
                                </Form.Item>
                            </Form.Item>

                            <Form.Item name="price" label="Narxi">
                                <Form.Item name="price" noStyle>
                                    <InputNumber
                                        style={{
                                            width: "auto",
                                        }}
                                    />
                                </Form.Item>
                            </Form.Item>

                            <Form.Item
                                name="owner"
                                label="Baza"
                                rules={[
                                    {
                                        required: true,
                                        message: "Baza harfini yozing",
                                    },
                                ]}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Button
                                type="primary"
                                style={{
                                    width: "100%",
                                }}
                                htmlType="submit"
                            >
                                Qo'shish
                            </Button>
                        </Form>
                    </Modal>

        </>
    );
}
